/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MailOffIcon20Solid = forwardRef('MailOffIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.707.293a1 1 0 0 0-1.414 1.414L3.825 4.24A3 3 0 0 0 2 7v6a3 3 0 0 0 3 3h10c.184 0 .363-.017.538-.048l2.255 2.255a1 1 0 0 0 1.414-1.414L2.707.293Zm8.434 11.262-1.301-1.3a1.744 1.744 0 0 1-1.06-.49L5.576 6.65a.75.75 0 1 0-1.046 1.075l3.202 3.116a3.25 3.25 0 0 0 3.408.715Z" }),
        React.createElement("path", { d: "M15.469 7.724 14.034 9.12 18 13.085 18 13V7a3 3 0 0 0-3-3H8.914l4.06 4.06 1.449-1.411a.75.75 0 0 1 1.046 1.075Z" })));
});
